"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonThemeableRules = exports["default"] = void 0;
// Setting up nonThemeableRules for use within the React component generator
var nonThemeableRules = {
  packageName: 'UkLegacyIcons',
  colorAppliesTo: 'fill',
  defaultSize: 3,
  hasNumberBadge: false,
  size: {
    1: {
      sm: 16,
      md: 16,
      lg: 16,
      xl: 16
    },
    2: {
      sm: 16,
      md: 24,
      lg: 24,
      xl: 24
    },
    3: {
      sm: 24,
      md: 32,
      lg: 32,
      xl: 32
    },
    4: {
      sm: 24,
      md: 32,
      lg: 40,
      xl: 40
    },
    5: {
      sm: 32,
      md: 40,
      lg: 48,
      xl: 48
    }
  },
  appearance: {
    primary: {
      inverse: {}
    },
    secondary: {
      inverse: {}
    },
    alt1: {
      inverse: {}
    }
  },
  state: {
    success: {},
    error: {},
    info: {},
    warn: {}
  }
};
exports.nonThemeableRules = nonThemeableRules;

var ruleSet = function ruleSet(theme) {
  // deep clone the nonThemeableRules to modify them in side this function
  var rules = JSON.parse(JSON.stringify(nonThemeableRules));
  rules.appearance = {
    primary: {
      color: theme.color.monochrome6["default"],
      inverse: {
        color: theme.inverseColor.monochrome6["default"]
      }
    },
    secondary: {
      color: theme.color.primary1["default"],
      inverse: {
        color: theme.inverseColor.primary1["default"]
      }
    },
    alt1: {
      color: theme.color.secondary1["default"],
      inverse: {
        color: theme.inverseColor.secondary1["default"]
      }
    }
  };
  rules.state = {
    success: {
      color: theme.color.success["default"]
    },
    error: {
      color: theme.color.error["default"]
    },
    info: {
      color: theme.color.info["default"]
    },
    warn: {
      color: theme.color.warn["default"]
    }
  };
  return rules;
};

var _default = ruleSet;
exports["default"] = _default;
//# sourceMappingURL=ruleSet.js.map